import Candidates from './Candidates';

export default Candidates;
